import React from "react";
import { NavLink, useLocation } from "react-router-dom";
import { Home, Video, Activity, User } from "lucide-react";

const items = [
  { to: "/dashboard", icon: Home, label: "Home", testid: "nav-home" },
  { to: "/awareness", icon: Video, label: "Awareness", testid: "nav-awareness" },
  { to: "/vitals", icon: Activity, label: "Vitals", testid: "nav-vitals" },
  { to: "/profile", icon: User, label: "Profile", testid: "nav-profile" },
];

const BottomNav = () => {
  const loc = useLocation();
  // Hide on auth, reels-full-screen (awareness detail), meeting
  const hide = ["/login", "/signup", "/"].includes(loc.pathname) ||
               loc.pathname.startsWith("/meeting");
  if (hide) return null;

  return (
    <nav
      data-testid="bottom-nav"
      className="fixed bottom-0 left-1/2 -translate-x-1/2 w-full max-w-[430px] h-[76px] bg-[#FFF7EE]/95 backdrop-blur-xl border-t border-[#0A4C36]/8 flex justify-around items-center px-2 z-40 pb-safe"
    >
      {items.map(({ to, icon: Icon, label, testid }) => (
        <NavLink
          key={to}
          to={to}
          data-testid={testid}
          className={({ isActive }) =>
            `flex flex-col items-center gap-1 py-2 px-3 rounded-2xl transition-all ${
              isActive ? "text-[#F4844B]" : "text-[#78716C]"
            }`
          }
        >
          {({ isActive }) => (
            <>
              <div className={`p-2 rounded-2xl transition-all ${isActive ? "bg-[#FCD9C8]" : ""}`}>
                <Icon size={20} strokeWidth={isActive ? 2.4 : 2} />
              </div>
              <span className="text-[10px] font-figtree font-medium tracking-wide">{label}</span>
            </>
          )}
        </NavLink>
      ))}
    </nav>
  );
};

export default BottomNav;
